<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.35 4.99999V1.34995H30.6501V4.99999H17.35ZM22.1891 27.9435H25.8109V16.387H22.1891V27.9435ZM23.9934 45.25C21.4093 45.25 18.9837 44.7577 16.7167 43.7731C14.4496 42.7885 12.4681 41.4497 10.7722 39.7568C9.07622 38.0639 7.73912 36.0847 6.76086 33.8193C5.78259 31.5539 5.29346 29.13 5.29346 26.5475C5.29346 23.9651 5.78344 21.5403 6.76341 19.273C7.74337 17.0058 9.08132 15.0224 10.7773 13.323C12.4732 11.6236 14.4547 10.2797 16.7217 9.29129C18.9887 8.30289 21.4148 7.80869 24 7.80869C26.271 7.80869 28.4134 8.18369 30.4272 8.93369C32.441 9.68369 34.2239 10.7348 35.7761 12.0869L38.5805 9.28259L41.1892 11.863L38.3848 14.6674C39.6037 16.0384 40.6334 17.6928 41.474 19.6304C42.3145 21.5681 42.7348 23.8725 42.7348 26.5435C42.7348 29.1299 42.2419 31.5576 41.2561 33.8265C40.2702 36.0955 38.928 38.0751 37.2294 39.7654C35.5307 41.4556 33.5461 42.7923 31.2755 43.7754C29.0049 44.7585 26.5775 45.25 23.9934 45.25ZM23.9952 41.2609C28.1085 41.2609 31.5953 39.8371 34.4555 36.9896C37.3156 34.1422 38.7457 30.6617 38.7457 26.5483C38.7457 22.435 37.3172 18.9482 34.4603 16.0881C31.6034 13.2279 28.1182 11.7978 24.0049 11.7978C19.8915 11.7978 16.4047 13.2263 13.5446 16.0832C10.6844 18.9401 9.25436 22.4253 9.25436 26.5386C9.25436 30.652 10.6828 34.1341 13.5397 36.9848C16.3966 39.8355 19.8818 41.2609 23.9952 41.2609Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
